import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuestAlertRoutingModule } from './guest-alert-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    GuestAlertRoutingModule
  ]
})
export class GuestAlertModule { }
